export default "__VITE_ASSET__DnPZcZBU__"